import React, { useState, useCallback, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ChatAnswer from "./chatAnswer/index";
import ComposeDialog from "src/components/compose/components/dialog";
import { invalidateSeekEmailResponse } from "src/redux/actions/seek";

import styles from "./chat.module.scss";
import cx from "classnames";
import _ from "lodash";

interface SeekChatProps {
  sessionView: boolean;
  seekAsset?: boolean;
  seekAnswer?: string | null;
}

const SeekChat: React.FC<SeekChatProps> = ({ sessionView, seekAsset , seekAnswer}) => {
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const seekEmailResponse = useSelector((state: any) => {
    const body = _.get(state,"seek.email.body");
    if(!body){
      return body;
    }

    return `${body}
      <p>&nbsp;</p>
      <div class="mceNonEditable widget" data-widget-id="assets.grid">
        {{> AssetAttachments}}
      </div>    
    `
  });
  const profile = useSelector((state: any) => state.users.me);
  const chats = useSelector((state: any) => state.seek.session.item.chats);
  const sessionLoading = useSelector((state: any) =>
    _.get(state, "seek.session.loading", false),
  );
  const [completedChats, setCompletedChats] = useState<{
    [key: number]: boolean;
  }>({});

  const [showCompose, setShowCompose] = useState(false);
  const [assetsForCompose, setAssetsForCompose] = useState<any[] | null>([]);
  

  const handleComplete = useCallback((index: number) => {
    setCompletedChats((prev) => ({ ...prev, [index]: true }));
  }, []); 

  const handleDiscardEmail = () => {
    setShowCompose(false);
    dispatch(invalidateSeekEmailResponse());
  };

  const scrollToBottom = () => {
    if (chatContainerRef && chatContainerRef.current) {
      const scrollTop = _.floor(chatContainerRef.current.scrollTop);
      const scrollHeight = _.floor(chatContainerRef.current.scrollHeight);
      const clientHeight = _.floor(chatContainerRef.current.clientHeight);
      if (scrollTop + clientHeight >= scrollHeight) {
        return;
      }
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (seekAnswer ) {
      const lastIndex = chats.length - 1;
      setCompletedChats(prev => ({ ...prev, [lastIndex]: true }));
    }
  }, []);
  
  return (
    <div
      ref={chatContainerRef}
      className={cx(
        styles.chatContainer,
        sessionView && styles.sessionViewChatContainer,
        seekAsset && styles.seekAssetChatContainer,
      )}
    >
      {chats.map((chat: any, index: number) => (
        <React.Fragment key={index}>
          <ChatAnswer
            setAssetsForCompose={setAssetsForCompose}
            setShowCompose={setShowCompose}
            index={index}
            chat={chat}
            profile={profile}
            handleComplete={handleComplete}
            skipTypewriting={!!completedChats[index]}
            showDivider={chats.length > 1}
            seekAsset={seekAsset}
            scrollToBottom={scrollToBottom}
          />
        </React.Fragment>
      ))}
      {sessionLoading && _.size(chats) === 0 && (
        <span className={styles.loading}>Loading...</span>
      )}

      <ComposeDialog
        show={showCompose}
        dialog={true}
        sourceType="Share Asset"
        initialContent={assetsForCompose}
        emailBody={seekEmailResponse}
        onClose={() => handleDiscardEmail()}
        onFinish={() => handleDiscardEmail()}
      />

    </div>
  );
};

export default SeekChat;
